// frontend/src/config/events.js

// Define all supported events
export const SUPPORTED_EVENTS = ['mjwc2025', 'wjwc2025'];

// Event configurations
export const EVENT_CONFIG = {
  mjwc2025: {
    displayName: "Men's Junior World Cup 2025",
    shortName: "MJWC 2025",
    dbName: "MJWC 2025",
    startDate: "2025-03-01",
    endDate: "2025-03-15",
    location: "Kuala Lumpur, Malaysia"
  },
  wjwc2025: {
    displayName: "Women's Junior World Cup 2025",
    shortName: "WJWC 2025",
    dbName: "WJWC 2025",
    startDate: "2025-04-01",
    endDate: "2025-04-15",
    location: "Santiago, Chile"
  },
  // Add more events as needed
  // mjwc2026: {
  //   displayName: "Men's Junior World Cup 2026",
  //   shortName: "MJWC 2026",
  //   dbName: "MJWC 2026",
  //   startDate: "2026-03-01",
  //   endDate: "2026-03-15",
  //   location: "TBD"
  // }
};

// Helper functions
export const getEventDisplayName = (eventCode) => {
  return EVENT_CONFIG[eventCode]?.shortName || eventCode.toUpperCase();
};


export const getEventDetails = (eventCode) => {
  return EVENT_CONFIG[eventCode] || null;
};

// Check if an event is valid
export const isValidEvent = (eventCode) => {
  return SUPPORTED_EVENTS.includes(eventCode);
};